import React from 'react'
import { Link } from 'react-router-dom'
import locale from 'parent/i18n/react'
import Constants from 'scripts/base/Constants'

class NotFound extends React.Component {
  constructor(props) {
    super(props)
    this.lang = locale.getLanguage() || Constants.DefaultLang
  }

  render() {
    const langPrefix = this.lang !== Constants.DefaultLang ? this.lang : ''
    return (
      <div className="flex flex-center full-bg center-align text-no-spacing">
        <div>
          <h1 className="screamer">404</h1>
          <p className="screamer-subheader">{locale.notFound}</p>
          <div className="section">
            <Link to={`/${langPrefix}`} className="btn btn-unicorn">{locale.buttons.backHome}</Link>
          </div>
        </div>
      </div>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./assets/js/components/notfound.jsx